import api from './api';

const billingService = {
  // ── Core CRUD ──────────────────────────────────────────────────────────────
  createBilling: (data) => api.post('/billing', data).then(r => r.data),
  getAllBillings: (params = {}) => api.get('/billing', { params }).then(r => r.data),
  getBillingById: (id) => api.get(`/billing/${id}`).then(r => r.data),
  updateBilling: (id, data) => api.put(`/billing/${id}`, data).then(r => r.data),
  deleteBilling: (id) => api.delete(`/billing/${id}`).then(r => r.data),

  // ── Actions ────────────────────────────────────────────────────────────────
  updatePayment:        (id, data) => api.post(`/billing/${id}/payment`, data).then(r => r.data),
  approveBilling:       (id)       => api.post(`/billing/${id}/approve`).then(r => r.data),
  cancelBilling:        (id, data) => api.post(`/billing/${id}/cancel`, data).then(r => r.data),
  duplicateBilling:     (id)       => api.post(`/billing/${id}/duplicate`).then(r => r.data),
  saveBilling:          (id)       => api.post(`/billing/${id}/save`).then(r => r.data),
  convertToSales:       (id, data) => api.post(`/billing/${id}/convert-to-sales`, data).then(r => r.data),

  // ── Reports ────────────────────────────────────────────────────────────────
  getStats:                  (params = {}) => api.get('/billing/stats', { params }).then(r => r.data),
  getOutstandingReceivables: (params = {}) => api.get('/billing/outstanding/receivables', { params }).then(r => r.data),
  getOutstandingPayables:    (params = {}) => api.get('/billing/outstanding/payables', { params }).then(r => r.data),
  getPartyLedger:            (params = {}) => api.get('/billing/ledger', { params }).then(r => r.data),

  // ── GST ───────────────────────────────────────────────────────────────────
  getGstTaxSummary:   (params = {}) => api.get('/billing/gst/tax-summary', { params }).then(r => r.data),
  getGstSettings:     ()            => api.get('/billing/gst/settings').then(r => r.data),
  updateGstSettings:  (data)        => api.put('/billing/gst/settings', data).then(r => r.data),

  downloadGstr1Json: async (params = {}) => {
    const res = await api.get('/billing/gst/gstr1-json', { params, responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `GSTR1_${params.month || 'export'}.json`;
    a.click();
    URL.revokeObjectURL(url);
  },

  downloadPurchaseJson: async (params = {}) => {
    const res = await api.get('/billing/gst/purchase-json', { params, responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `PURCHASE_REGISTER_${params.month || 'export'}.json`;
    a.click();
    URL.revokeObjectURL(url);
  },

  downloadGstExcelReport: async (params = {}) => {
    const res = await api.get('/billing/gst/excel-report', { params, responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `GST_Report_${params.month || 'export'}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export default billingService;